<div class="At-Container At-ContainerAudioCall At-VideoCall">

    <div class="At-VideoStream">
        <div class="overlay2"></div>
        <figure>
            <img src="assets/images/calling/video2.jpg" class="img-fluid" alt="">
        </figure>
    </div>
    <!-- At-VideoStream ends  -->
    <div class="At-CallHeader d-flex align-items-center justify-content-between">
        <div>
            <a href="javascript:void(0);" class="At-DownArrow">
                <i class="icon-down-arrow"></i>
            </a>
        </div>
       <div class="At-CallHeaderText">
        <h4>Anita Enzo • Enzzy</h4>
        <h5>02:09</h5>
       </div>
       <div>
           <a class="At-AddUser" routerLink="/group-call">
              <i class="icon-user-add"></i>
           </a>
       </div>
    </div>
    <!-- At-CallHeader ends -->
    <div class="At-VideoCallingIcon">
        <div class="At-VideoCallingIconInner">
            <figure>
                <img src="assets/images/calling/video-my.png" class="img-fluid" alt="">
            </figure>
        </div>
    </div>
    <!-- At-VideoCallingIcon ends  -->
    <div class="At-CallingControls">
        <div class="At-CtrlUp">
            <a href="#" routerLink="/dashboard" class="At-CancelBtn"><i class="icon-phone-1"></i></a>
        </div>
        <div class="At-CtrlDown d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="At-IconBtnBlue"><i class="icon-gallery"></i></a>
                <a href="javascript:void(0);" class="At-IconBtnBlue At-MarginL4rem" routerLink="/screen-share"><i class="icon-copy"></i></a>
            </div>
            <div class="At-CtrlCenter d-flex align-items-center">
                <a href="javascript:void(0);"><i class="icon-sound-on"></i></a>
                <a href="javascript:void(0);" class="At-IconVideo" routerLink="/video-call"><i class="icon-video-camera"></i></a>
                <a href="javascript:void(0);"><i class="icon-mike-off"></i></a>
            </div>
            <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="At-IconBtnBlue invisible"><i class="icon-magic-pen"></i></a>
                <a href="javascript:void(0);" class="At-IconBtnBlue At-MarginL4rem"><i class="icon-magic-pen"></i></a>
            </div>
        </div>
    </div>
    <!-- At-CallingControls ends -->
</div>

